var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberSixFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberSixFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM11.2143 8.26786C10.8496 8.26786 10.4999 8.41272 10.242 8.67058C9.98415 8.92845 9.83929 9.27818 9.83929 9.64286V10.9204C10.2715 10.7257 10.7402 10.625 11.2143 10.625H12.7857C14.6306 10.625 16.125 12.1194 16.125 13.9643V14.3571C16.125 15.2428 15.7732 16.0921 15.1469 16.7184C14.5207 17.3446 13.6713 17.6964 12.7857 17.6964H11.2143C10.3287 17.6964 9.47929 17.3446 8.85305 16.7184C8.22682 16.0921 7.875 15.2428 7.875 14.3571V9.64286C7.875 7.798 9.36943 6.30357 11.2143 6.30357H12.7857C14.2409 6.30357 15.4776 7.23386 15.9349 8.53029C16.0215 8.77597 16.0071 9.04603 15.8947 9.28105C15.7822 9.51608 15.581 9.69681 15.3354 9.7835C15.0897 9.87019 14.8196 9.85573 14.5846 9.7433C14.3496 9.63087 14.1688 9.42969 14.0821 9.184C13.9871 8.91613 13.8114 8.68427 13.5793 8.52023C13.3472 8.35619 13.07 8.26803 12.7857 8.26786H11.2143ZM9.83929 14.3571V14.3619C9.84053 14.7257 9.98595 15.0742 10.2437 15.3311C10.5014 15.5879 10.8504 15.7321 11.2143 15.7321H12.7857C13.1504 15.7321 13.5001 15.5873 13.758 15.3294C14.0158 15.0716 14.1607 14.7218 14.1607 14.3571V13.9643C14.1607 13.5996 14.0158 13.2499 13.758 12.992C13.5001 12.7342 13.1504 12.5893 12.7857 12.5893H11.2143C10.851 12.5893 10.5024 12.7331 10.2448 12.9892C9.98714 13.2454 9.84136 13.5931 9.83929 13.9564V14.3571Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberSixFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberSixFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberSixFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-six-filled') === undefined) {
    customElements.define('cat-icon-number-six-filled', BlocksIconNumberSixFilled);
}
